var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isIE)?_c('v-lazy',_vm._b({},'v-lazy',_vm.lazyProps,false),[_vm._t("default")],2):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }